import React, { useState, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Col, Input, InputGroup, InputGroupText, Modal, Row } from 'reactstrap';
import { AuthContext } from 'contexts/AuthContext';
import { SpinnerButton } from 'common/SpinnerButton';
import { login } from 'utils/api/authAPI';
import Logo from 'images/logo.png';
import { MicrosoftLogin } from '../../../../MicrosoftLogin';

export const PublicModalSignIn = ({ toggle, publicEmail, setPublicEmail, isOpen, isPublic }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { signIn, authorizeManagePublicReader, fetchReaderProfile } = useContext(AuthContext);
    const [submitting, setSubmitting] = useState(false);
    const [password, setPassword] = useState('');
    const [err, setErr] = useState(false);
    const [additionalErr, setAdditionalErr] = useState(null);
    const urlParams = new URLSearchParams(window.location.search);
    const hash = urlParams.get('h');

    const onSubmit = async () => {
        setSubmitting(true);

        try {
            const res = await login(publicEmail, password);

            if ((res?.area && res?.area === 'reader') || !isPublic) {
                await authorizeManagePublicReader(res.token, hash, id);
                const userId = await fetchReaderProfile();
                await navigate(`/account/reader/${userId}`);
            } else {
                signIn(res.token);
            }

            toggle();
        } catch (err) {
            if (err.code === 'AUTHENTICATION_FAILED') {
                setAdditionalErr('Incorrect password');
            } else {
                setErr(true);
            }
        }

        setSubmitting(false);
    };

    const resetUrl = id ? `/reader/${id}/forgot-password` : `/reader/forgot-password`;

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="reader-signin-modal">
            <div className="auth-block">
                <div className="animated fadeIn">
                    <Row className="justify-content-center mt-2" style={{ marginBottom: '.5rem' }}>
                        <Col md={9}>
                            <div className="auth-block__image-container">
                                <a href="/">
                                    <img src={Logo} alt="Ozmosys" className="auth-block__image img-fluid" />
                                </a>
                            </div>

                            <div className="text-center">
                                <h2>Sign In</h2>
                                <p className="mb-4 mt-3 text-muted">Enter your password to manage alerts</p>
                            </div>

                            {(err || additionalErr) &&
                                <div className="error-block mb-3">
                                    <p><b>Access Denied</b></p>
                                    {additionalErr && <p>{additionalErr}</p>}
                                    {!additionalErr && <p>You are not authorized to access this application.
                                        Please contact <a href="mailto:support@ozmosys.com?subject=Access Denied Help"
                                            target="_blank">Ozmosys</a>
                                        , if you believe this is an error.</p>
                                    }
                                </div>
                            }

                            {process.env.REACT_APP_MICROSOFT_CLIENT_ID &&
                                <MicrosoftLogin
                                    err={err}
                                    setErr={setErr}
                                    email={''}
                                    setPublicEmail={setPublicEmail}
                                    redirectUrlPath={'/signin'}
                                    setAdditionalErr={setAdditionalErr}
                                    toggle={toggle}
                                />
                            }

                            <InputGroup>
                                <InputGroupText>@</InputGroupText>
                                <Input placeholder="Email" name="email" value={publicEmail} type="email" disabled autoComplete="email" />
                            </InputGroup>

                            <InputGroup>
                                <InputGroupText>
                                    <i className="fa fa-lock" />
                                </InputGroupText>

                                <Input
                                    placeholder="Password"
                                    name="password"
                                    value={password}
                                    autoComplete="password"
                                    onChange={(e) => setPassword(e.target.value)}
                                    type="password"
                                />
                            </InputGroup>

                            <Row className="mb-4">
                                <Col xs="12" className="text-left">
                                    <SpinnerButton
                                        color="primary"
                                        block
                                        disabled={password.length < 1}
                                        onClick={onSubmit}
                                        submitting={submitting}
                                        title="Login"
                                    />

                                    <div className="mt-1">
                                        <Link to={resetUrl} className="nav-link">
                                            Set or reset password
                                        </Link>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        </Modal>
    );
};
